import QuestionRepository from '../../../../repositories/QuestionRepository';

export default {
    sender:       {
        name: null
    },
    recipient:    {
        email: null
    },
    inquiry:      {
        department: null
    },

    QuestionRepository: new QuestionRepository()
}
